import { type FormItemProps, Select, type SelectProps } from "antd";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import CustomSelect from "../../CustomSelect";
import { FormItem } from "../FormItem";
import { FormSkeleton } from "../FormSkeleton";

type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;
  showSkeleton?: boolean;

  /** `disabled` moved out of `selectProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `SelectProps`. */
  selectProps?: Omit<SelectProps, "disabled">;
};

export const FormSelectYesNo = <TForm = unknown>({
  label,
  disabled,
  showSkeleton = false,
  selectProps,
  ...rest
}: Props<TForm>) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      {showSkeleton ? (
        <FormSkeleton label={label} />
      ) : (
        <FormItem<TForm> layout="vertical" label={label} {...rest}>
          <CustomSelect disabled={disabled} {...selectProps}>
            <Select.Option value>{formatMessage({ id: "yes" })}</Select.Option>
            <Select.Option value={false}>{formatMessage({ id: "no" })}</Select.Option>
          </CustomSelect>
        </FormItem>
      )}
    </div>
  );
};
